export default __webpack_public_path__ + "static/media/btn_arrow_up.730fe4f5.svg";